import { strip_empty_label_plugin } from "./Strip_empty_label_plugin";

export const optionsWindSpd = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      distribution: "linear",
      title: {
        display: true,
        text: "Windsnelheid (knopen)",
      },
      ticks: {
        beginAtZero: true,
        min: 0,
        max: 30,
      },
    },
    x: {
      type: "time",
      title: {
        display: true,
        text: "Tijd",
      },

      distribution: "linear",
      bounds: "data",
      time: {
        displayFormats: {
          hour: "H:mm",
          minute: "H:mm",
        },
        tooltipFormat: "H:mm",
      },
      ticks: {
        beginAtZero: true,
        maxRotation: 0,
      },
    },
  },

  plugins: {
    title: {
      text: "Wind IJmuiden Zuid havenhoofd 2022-May-22",
      display: true,
    },

    legend: {
      display: true,
      labels: {
        generateLabels: strip_empty_label_plugin,
      },
    },
    tooltip: {
      enabled: true,
      axis: "xy",
      mode: "x",
      intersect: false,
      callbacks: {
        //label: labelCallback("blaa"),
      },
    },
  },
};
